module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp1_3009.8f8ff860.png";